import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const rp = (n) => "Rp" + Number(n || 0).toLocaleString("id-ID");
const TEXT = {
  delete: { title: "Hapus Permanen Invoice Barang/Jasa", desc: "Invoice yang dihapus hilang permanen. Hanya invoice tanpa pembayaran aktif dan belum VOID yang dapat dihapus.", btn: "Hapus Permanen", url: "/billing/nb-invoices/bulk-delete" },
  void: { title: "Void Invoice Barang/Jasa Terpilih", desc: "Void membatalkan dokumen tagihan (bukan pembayaran). Invoice VOID tetap tersimpan sebagai riwayat dan tidak dapat dibayar lagi. Invoice yang memiliki pembayaran aktif akan ditolak.", btn: "Void Invoice", url: "/billing/nb-invoices/bulk-void" },
};

export const NbBulkActionDialog = ({ mode, items: itemsProp, onClose, onDone }) => {
  const t = TEXT[mode];
  // Snapshot items on open: parent clears selection in onDone, which would otherwise empty the result list.
  const [items] = useState(itemsProp);
  const [alasan, setAlasan] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const byId = Object.fromEntries(items.map((i) => [i.id, i]));
  const run = async () => {
    setBusy(true);
    try {
      const body = { ids: items.map((i) => i.id), ...(mode === "void" ? { alasan: alasan.trim() } : {}) };
      const { data } = await api.post(t.url, body);
      setRes(data);
      if (data.failed === 0) toast.success(`${data.success} invoice berhasil ${mode === "void" ? "di-VOID" : "dihapus"}`);
      else toast.warning(`${data.success} berhasil, ${data.failed} gagal — lihat rincian`);
      onDone();
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Gagal memproses");
    } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && !busy && onClose()}>
      <DialogContent className="max-w-lg" data-testid={`nb-bulk-${mode}-dialog`}>
        <DialogHeader><DialogTitle>{t.title}</DialogTitle><DialogDescription>{t.desc}</DialogDescription></DialogHeader>
        <div className="max-h-[260px] space-y-1 overflow-y-auto rounded-md border p-2 text-xs" data-testid={`nb-bulk-${mode}-list`}>
          {(res ? res.results : items.map((i) => ({ id: i.id }))).map((r) => {
            const i = byId[r.id] || {};
            return (
              <div key={r.id} className="flex items-start justify-between gap-2 border-b py-1 last:border-0" data-testid={`nb-bulk-${mode}-item-${i.nomor || r.id}`}>
                <span><b className="font-mono">{i.nomor}</b> · {i.customer_name} · {rp(i.total)}</span>
                {res && <span className={r.ok ? "font-bold text-[#047857]" : "text-right text-[#B91C1C]"} data-testid={`nb-bulk-${mode}-result-${i.nomor || r.id}`}>{r.ok ? "Berhasil" : `Gagal: ${r.reason}`}</span>}
              </div>
            );
          })}
        </div>
        {res && <div className="text-sm font-semibold" data-testid={`nb-bulk-${mode}-summary`}>{res.success} berhasil · {res.failed} gagal</div>}
        {!res && mode === "void" && (
          <div className="space-y-1"><Label htmlFor="nb-bulk-void-reason">Alasan void (wajib, min. 3 karakter)</Label>
            <Input id="nb-bulk-void-reason" value={alasan} onChange={(e) => setAlasan(e.target.value)} data-testid="nb-bulk-void-reason" /></div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy} data-testid={`nb-bulk-${mode}-close`}>{res ? "Tutup" : "Batal"}</Button>
          {!res && <Button variant="destructive" onClick={run} disabled={busy || (mode === "void" && alasan.trim().length < 3)} data-testid={`nb-bulk-${mode}-confirm`}>
            {busy ? "Memproses…" : `${t.btn} (${items.length})`}</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
